<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card common-bg" shadow="never">
      <div slot="header" class="clearfix" style="position:relative;">
        <el-button type="danger" class="button_red_color">配资账户</el-button>
        <el-button  class="button_red_outline" style="float: right" @click="goApply">申请新配资账号</el-button>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane name="1" label="配资中">
          <el-button type="primary" class="button_red_color" @click="changeList('all')">全部</el-button>
          <el-button type="primary" class="button_red_color" @click="changeList('day')">按天</el-button>
          <el-button type="primary" class="button_red_color" @click="changeList('week')">按周</el-button>
          <el-button type="primary" class="button_red_color" @click="changeList('month')">按月</el-button>
          <el-button type="primary" class="button_red_color" @click="changeList('free')">免息</el-button>
          <div class="sell_top" v-for="(item,index) in currentList" :key="index">
            <p class="capital_d1">
              {{item.name}}
              <span style="color:#A29BA9">{{item.order}}</span>
              <span style="color:#A29BA9;margin-left:20px;">{{item.time}}</span>
            </p>
            <br>
            <p class="capital_d2">
              账户管理费：{{item.manage}}元
              <!--              /{{text}}-->
              <!--              <span>已策略天数：{{day}}个{{text}}</span>-->
            </p>
            <br>
            <ul v-if="is_short_trading_enable == 1" class="entrust_ul" style="margin-top:-30px;">
              <!-- <li class="entrust_ul_active">
                <router-link :to="{name:'Stockdetailed',query:{cid:item.cid,symbol:'sh000001'}}">交易委托</router-link>
              </li> -->
              <li class="entrust_ul_active" v-if="item.direction_capital==2||item.direction_capital==0"><router-link :to="{path: '/stockdetailed',query:{cid:item.cid,symbol:'sz000001',direction:0}}">做多交易</router-link></li>      
              <li v-bind:class="[item.direction_capital==2 ? 'entrust_ul_not_active' : 'entrust_ul_active']"  v-if="item.direction_capital==2||item.direction_capital==1"><router-link :to="{path: '/stockdetailed',query:{cid:item.cid,symbol:'sz000001',direction:1}}">做空交易</router-link></li>
<!--              <li @click="showProfit(item.cid)">提取利润</li>-->
              <li class="entrust_ul_not_active" @click="showAdd(item.cid)">追加配资</li>
              <li  class="entrust_ul_not_active" @click="showBondAdd(item.cid)">追加保证金</li>
              <li  class="entrust_ul_not_active" @click="getCapitalData(item.cid,'all')">资金明细</li>
              <li  class="entrust_ul_not_active" @click="showSettlement(item.cid)" style="margin-right: 30px;">申请结算</li>
            </ul>
            <ul v-if="is_short_trading_enable == 0" class="entrust_ul" style="margin-top:-30px;">
              <!-- <li class="entrust_ul_active">
                <router-link :to="{name:'Stockdetailed',query:{cid:item.cid,symbol:'sh000001'}}">交易委托</router-link>
              </li> -->
              <li class="entrust_ul_active" ><router-link :to="{name:'Stockdetailed',query:{cid:item.cid,symbol:'sz000001',direction:0}}">实盘交易</router-link></li>      
<!--              <li @click="showProfit(item.cid)">提取利润</li>-->
              <li class="entrust_ul_not_active" @click="showAdd(item.cid)">追加配资</li>
              <li  class="entrust_ul_not_active" @click="showBondAdd(item.cid)">追加保证金</li>
              <li  class="entrust_ul_not_active" @click="getCapitalData(item.cid,'all')">资金明细</li>
              <li  class="entrust_ul_not_active" @click="showSettlement(item.cid)" style="margin-right: 30px;">申请结算</li>
            </ul>
            <p class="entrust_p3"></p>
            <div class="entrust_center clearfix">
              <div class="entrust_centerLeft">
                <h4>当前总资产(元)</h4>
                <p class="entrust_p4">{{item.total}}</p>
                <p class="entrust_p5">
                  当前盈亏(元)
                  <span style="color:#D02E27;background-color:#F2F2F2;padding:10px 3px 10px 2px;border-radius:8px;font-size: 11px;">{{( Number(item.divided)*100) }}%利益分配</span>
                </p>
                <p class="entrust_p6" v-bind:style="item.profit_loss >= 0 ?'color:#D02E27':'color:#3F7A21'">
                  {{item.profit_loss}}
                  <span>{{item.proportion}}%</span>
                </p>
              </div>
              <div class="entrust_centerRight">
                <p class="entrust_p7">
                  <span>持仓市值<a href="javascript:void(0);" class="text_red_color font12" @click="getHoldData(item.cid)">[明细]</a></span>
                  <span>持仓比例</span>
                  <span>可用余额<a href="javascript:void(0);" class="text_red_color font12" @click="getCapitalData(item.cid,'all')">[明细]</a></span>
                </p>
                <p class="entrust_p7" style="margin: 30px 0 43px 0;font-weight: 600;">
                  <span>{{Number(item.market).toFixed(2)}}</span>
                  <span>{{item.depot_ratio}}</span>
                  <span>{{item.use}}</span>
                </p>
                <p class="entrust_p7" style="margin-bottom: 30px;">
                  <span>总配资资金<a href="javascript:void(0);" class="text_red_color font12" @click="getCapitalData(item.cid,'money')">[明细]</a></span>
                  <span>申请额度</span>
                  <span>风险保证金<a href="javascript:void(0);" class="text_red_color font12"
                                @click="getCapitalData(item.cid,'ensure')">[明细]</a></span>
                </p>
                <p class="entrust_p7" style="font-weight: 600;margin-bottom: 50px;">
                  <span>{{item.total_capital}}</span>
                  <span>{{item.number}}</span>
                  <span>{{item.bond}}</span>
                </p>
              </div>
            </div>
            <p class="entrust_p8">
              <!-- 当前仓位：
              <span>0.00%</span>-->
            </p>
            <p class="entrust_p9">
              <span style="width: 330px;
  border-bottom: 4px solid black;"></span>
              <span style="width: 330px;
  border-bottom: 4px solid #D02E27;"></span>
              <span style="width: 265px;
  border-bottom: 4px solid #3f7a21;"></span>
            </p>
            <p class="entrust_p10">
              <span style="color:black">亏损平仓线（亏损比）：{{item.close}}元 ({{ item.close_line_ratio }})</span>
              <span class="text_red_color">亏损警戒线 (亏损比) ：{{item.warning}}元 ({{ item.warning_line_ratio }})</span>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2" label="已完成">
          <!--   <el-button type="primary" @click="changeList('all')">全部</el-button>
             <el-button type="primary" @click="changeList('day')">按天</el-button>
             <el-button type="primary" @click="changeList('week')">按周</el-button>
             <el-button type="primary" @click="changeList('month')">按月</el-button>
             <el-button type="primary" @click="changeList('free')">免息</el-button>-->
          <ul class="sell_ul1">
            <li v-for="(item,index) in historyList" :key="index" @click="goDetails(item.cid)">
              <p class="sell_p8"></p>
              <div>
                <div class="sell_title">
                  <p>{{item.name}}({{item.order}})</p>
                  <span></span>
                  <small>{{item.time}}</small>
                </div>
                <p class="sell_p9" style="margin-top: 38px;">
            <span>
              申请额度：
              <small>{{item.total}}</small>
            </span>
                  <span>
              盈亏：
              <small style="color: #D02E27;">{{item.profit}}({{item.proportion}}%)</small>
            </span>
                  <span>
              <small></small>
            </span>
                </p>
                <p class="sell_p9" style="margin-bottom: 45px;">
            <span>
              触发警戒：
              <small style="color: #f06f11;">{{item.warning}}</small>
            </span>
                  <span>
              触发止损：
              <small style="color: #D02E27;">{{item.close}}</small>
            </span>
                  <span>
              冻结资金：
              <small style="color: #0D268D;">{{item.bond}}</small>
            </span>
                </p>
              </div>
            </li>
          </ul>
          <div style="margin-top: 25px; margin-bottom: 25px; color: red; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!-- 弹窗-利润提取 -->
    <div class="show2Box moduleBox">
      <div class="show2">
        <div class="show2_title">
          <div>利润提取</div>
          <div @click="hiddenProfit()">x</div>
        </div>
        <div class="show2_content">
          <div>策略账户余额：{{available}}元</div>
          <div>当前盈利：{{extractProfit}}元</div>
          <div>
            <img src="../assets/img/sell_get.png">
            <input v-model="extractMoney" type="number" placeholder="请输入提取金额">
          </div>
          <div>最高可提利润{{extractMax}}元</div>
        </div>
        <div class="show2_foot">
          <button @click="operationProfit()">确认</button>
        </div>
      </div>
    </div>
    <!-- 弹窗 追加策略 -->
    <div class="show3Box moduleBox" >
      <div class="show3" style="height:500px !important;width:650px !important">
        <div class="show2_title" style="width:500px;">
          <div class="text_red_color"  style="margin-top:10px;font-size: 21px;font-weight: 100;">追加配资</div>
          <div @click="hiddenAdd()"  style="margin-top:10px;">x</div>
        </div>
        <div class="show2_content_a">
          <div class="strategynow_matching_amt">
            <img src="../assets/img/sell_get.png" style="margin-top:-20px;">
            <input oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px;margin-top:-20px;font-size:15px" type="digit" v-model="addMoney" placeholder="请输入追加金额 最低100元起">
          </div>
          <div class="show_content_strategynow" style="margin-bottom:15px !important;">
            <el-row>
                <el-col :span="8" style="text-align: left;padding:15px 20px 23px 25px;background-color: #f2f2f2;border-top-left-radius: 9px;border-bottom-left-radius: 9px;;" >
                  <p class="text_red_color" >对比项目</p>
                  <p style="margin-top:5px;">总账户余额</p>
                  <p style="margin-top:5px;">子账户余额</p>
                  <p style="margin-top:5px;">亏损警戒线</p>
                  <p style="margin-top:5px;">亏损警戒线亏损比</p>
                  <p style="margin-top:5px;">亏损平仓线</p>
                  <p style="margin-top:5px;">亏损平仓线亏损比</p>
                </el-col>
                
                <el-col :span="8" style="text-align: left;padding:15px 20px 23px 25px;">
                  <p>当前数据</p>
                  <p style="margin-top:5px;">{{cashCapitalInfo}}元</p>
                  <p style="margin-top:5px;">{{balance}}元</p>
                  <p style="margin-top:5px;">{{warningIncreaseInfo}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{warning_line_ratio_increase_info}}</p>
                  <p style="margin-top:5px;">{{closeIncreaseInfo}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{close_line_ratio_increase_info}}</p>
                </el-col>
                <el-col :span="8" style="text-align: left;padding:15px 20px 23px 25px;">
                  <p>追加后数据</p>
                  <p style="margin-top:5px;">{{afterCashCapitalInfo}}元</p>
                  <p style="margin-top:5px;">{{balanceAfter}}元 </p>
                  <p style="margin-top:5px;">{{warningIncreaseInfoAfter}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{warning_line_ratio_increase_info_after}}%</p>
                  <p style="margin-top:5px;">{{closeIncreaseInfoAfter}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{close_line_ratio_increase_info_after}}%</p>
                </el-col>
</el-row>
          </div>
        
       <div class="show_foot">
          <button class="button_red_color" @click="operationAdd()" style="width:550px;border-radius: 10px;">确认</button>
        </div>
      </div>
      </div>
    </div>
    <!-- 弹窗 追加履约金 -->
    <div class="show4Box moduleBox">
      <div class="show4" style="height:500px !important;width:650px !important">
        <div class="show2_title" style="width:500px;">
          <div class="text_red_color"  style="margin-top:20px;font-size: 21px;font-weight: 100;">追加保证金</div>
          <div style="margin-top:20px;" @click="hiddenBondAdd()">x</div>
        </div>
        <div class="show2_content_a">

          <div class="strategynow_matching_amt">
            <img src="../assets/img/sell_get.png" style="margin-top:-20px;">
            <input oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px;margin-top:-20px;font-size:15px" type="digit" v-model="addBondMoney" placeholder="请输入追加金额 最低100元起">
          </div>
          <div class="show_content_strategynow" style="margin-bottom:15px !important;">
            <el-row>
                <el-col :span="8" style="text-align: left;padding:15px 20px 23px 25px;background-color: #f2f2f2;border-top-left-radius: 9px;border-bottom-left-radius: 9px;;" >
                  <p class="text_red_color">对比项目</p>
                  <p style="margin-top:5px;">总账户余额</p>
                  <p style="margin-top:5px;">子账户余额</p>
                  <p style="margin-top:5px;">亏损警戒线</p>
                  <p style="margin-top:5px;">亏损警戒线亏损比</p>
                  <p style="margin-top:5px;">亏损平仓线</p>
                  <p style="margin-top:5px;">亏损平仓线亏损比</p>
                </el-col>
                
                <el-col :span="8" style="text-align: left;padding:15px 20px 23px 25px;">
                  <p>当前数据</p>
                  <p style="margin-top:5px;">{{cashBondInfo}}元</p>
                  <p style="margin-top:5px;">{{balance}}元</p>
                  <p style="margin-top:5px;">{{warningIncreaseBondInfo}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{warning_line_ratio_increase_bond_info}}</p>
                  <p style="margin-top:5px;">{{closeIncreaseBondInfo}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{close_line_ratio_increase_bond_info}}</p>
                </el-col>
                <el-col :span="8" style="text-align: left;padding:15px 20px 23px 25px;">
                  <p>追加后数据</p>
                  <p style="margin-top:5px;">{{afterCashBondInfo}}元</p>
                  <p style="margin-top:5px;">{{balanceAfter}}元 </p>
                  <p style="margin-top:5px;">{{warningIncreaseBondInfo}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{warning_line_ratio_increase_bond_info_after}}%</p>
                  <p style="margin-top:5px;">{{closeIncreaseBondInfo}}元</p>
                  <p style="margin-top:5px;" class="text_red_color">-{{close_line_ratio_increase_bond_info_after}}%</p>
                </el-col>
</el-row>
        </div>
        <div class="show_foot">
          <button class="button_red_color" @click="operationBondAdd()" style="width:550px;border-radius: 10px;">确认</button>
        </div>
      </div>

      </div>
    </div>
    <!-- 弹窗 申请结算 -->
    <div class="show1Box moduleBox">
      <div class="show1">
        <div class="show1_title">
          <div class="text_blue_color">结算确认</div>
          <div @click="hiddenSettlement()">x</div>
        </div>
        <div class="show1_content">
          <div>确认结算当前策略？</div>
        </div>
        <div class="show1_foot">
          <button  class="button_blue_color" @click="operationSettlement()">确认</button>
        </div>
      </div>
    </div>

    <el-dialog title="对账单" :visible.sync="capitalState">
      <el-table
        height="500px"
        size="small"
        border
        :data="capitalData"
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="time"
          label="时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="股票"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          label="金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="余额"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="button_blue_color" @click="capitalState = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="持仓" :visible.sync="holdState">
      <el-table
        height="560px"
        size="small"
        :data="holdData"
        border
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="name"
          label="股票"
          align="center">
        </el-table-column>
        <el-table-column
          prop="market"
          label="市值"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          label="持仓"
          align="center">
        </el-table-column>
        <el-table-column
          prop="sellable"
          label="可用"
          align="center">
        </el-table-column>
        <el-table-column
          prop="newPrice"
          label="现价"
          align="center">
        </el-table-column>
        <el-table-column
          prop="price"
          label="成本"
          align="center">
        </el-table-column>
        <el-table-column
          prop="profitPrice"
          label="盈亏额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="priceRatio"
          label="盈亏幅"
          align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.priceRatio }}%</p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="holdState = false">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="资金" :visible.sync="moneyState">
      <el-table
        height="500px"
        size="small"
        border
        :data="moneyData"
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="time"
          label="时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          label="金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="余额"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="button_blue_color" @click="moneyState = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>


  <!--<div class="recharge_left capital_first">
    <p class="capital_p1">
      <span>当前策略</span>
    </p>
    <div class="sell_top" v-for="(item,index) in list" :key="index">
      <div class="sell_title">
        <p>{{item.name}}({{item.order}})</p>
        <span>提示：当账户触发预警时，系统将自动按照合约履约金10%补保</span>
        <small>{{item.time}}</small>
      </div>
      <div class="sell_content clearfix">
        <div class="sell_contentLeft">
          <img src="../assets/img/account_88.png" alt>
          <p class="sell_p1">
            <span>触发止损</span>
            <small style="color: #e53349;">{{item.close}}</small>
          </p>
          <p class="sell_p2">
            <span>触发预警</span>
            <small style="color: #ffd539;">{{item.warning}}</small>
          </p>
          &lt;!&ndash; <p class="sell_p3">
            <span>触发止盈</span>
            <small style="color: #68c90a;">8800.00</small>
          </p>&ndash;&gt;
          <p class="sell_p4">
            <span>当前额度</span>
            <small>{{item.use}}</small>
          </p>
          <p class="sell_p5">
            <span>冻结资金</span>
            <small>{{item.frozen}}</small>
          </p>
          &lt;!&ndash; <div id="myChart" style="width: 499px;height:255px;"></div> &ndash;&gt;
        </div>
        <div class="sell_contentRight">
          <p class="sell_p6" style="margin-top: 33px;">
            <span>
              申请额度：
              <small style="color: #121816;">{{item.total}}</small>
            </span>
            <span>
              触发警戒：
              <small style="color: #f06f11;">{{item.warning}}</small>
            </span>
          </p>
          <p class="sell_p6">
            <span>
              触发止损：
              <small style="color: #ed0003;">{{item.close}}</small>
            </span>
            <span>
              浮动盈亏：
              <small style="color: #ed0003;">{{item.profit_loss}}({{item.proportion}}%)</small>
            </span>
          </p>
          <p class="sell_p6">
            <span>
              冻结资金：
              <small style="color: #304479;">{{item.frozen}}</small>
            </span>
            <span>
              <small></small>
            </span>
          </p>
          <p class="sell_p7"></p>
          <a class="sell_btn" @click="goDeal(item)">去交易</a>
        </div>
      </div>
    </div>
  </div>-->
</template>
<script>
  import $ from "jquery";
  import eventBus from "../assets/js/eventBus";

  // import echarts from "echarts";

  export default {
    name: "Strategynow",
    data() {
      return {
        cashCapitalInfo:"0.00",
        afterCashCapitalInfo:"",
        cashBondInfo:"0.00",
        afterCashBondInfo:"",
        increase_bond_capital:"",
        increase_bond:"",
        warning_ratio:"0.00",
        close_ratio:"0.00",
        multiple:0,
        number:0,
        balanceAfter:"0.00",
        warning_line_ratio_increase_info:"0.00",
        close_line_ratio_increase_info:"0.00",
        warningIncreaseInfo: "0.00",
        closeIncreaseInfo: "0.00",
        warning_line_ratio_increase_info_after:"0.00",
        close_line_ratio_increase_info_after:"0.00",
        warningIncreaseInfoAfter: "0.00",
        closeIncreaseInfoAfter: "0.00",
        warning_line_ratio_increase_bond_info:"0.00",
        close_line_ratio_increase_bond_info:"0.00",
        warningIncreaseBondInfo: "0.00",
        closeIncreaseBondInfo: "0.00",
        warning_line_ratio_increase_bond_info_after:"0.00",
        close_line_ratio_increase_bond_info_after:"0.00",
        activeName: '1',
        cid: '',
        //全部子账户
        currentAllList: [],
        currentList: [],
        historyList: [],
        name: "",
        order: "",
        type: "", //策略类型  1天配 2月配
        time: "",
        total: "0.00",
        market: "0.00",
        depot_ratio: "",
        available: "0.00",
        profit_loss: "0.00",
        ratio: "0.00",
        warning: "0.00",
        close: "0.00",
        capital_total: "0.00",
        apply_quota: "0.00",
        bond: "0.00",
        divided: "0.00",
        manage: "0.00",
        day: "0.00",
        text: "交易日", //交易日 或者交易月
        extractProfit: "0.00", //利润提取 盈亏
        extractMax: "0.00", //最大提取金额
        extractMoney: "", //提取输入金额
        balance: "0.00", //余额
        minAdd: "0.00", //最低追加策略金额
        addMoney: "", //追加策略金额
        minBondAdd: "", //最低追保证金金额
        addBondMoney: "", //追加保证金 金额
        //对账单状态
        capitalState: false,
        //对账单数据
        capitalData: [],
        //持仓状态
        holdState:false,
        //持仓数据
        holdData:[],
        //资金状态
        moneyState:false,
        //资金数据
        moneyData:[],
        is_short_trading_enable:0,
      };

    },
    mounted: function () {
      this.getNowData();
      this.getHistoryData();
      this.fetch_is_short_trading_enable();
    },
    watch:{
      addMoney: function (value){
        if(value){
            //capital account balance after add values - increase capital
            let after_total = parseFloat(this.balance) + (parseFloat(this.multiple)*(parseFloat(value))) + parseFloat(value);
            this.balanceAfter = parseFloat(after_total).toFixed(2);

            //main after add values - increase capital
            let cash = (parseFloat(this.cashCapitalInfo) - parseFloat(value));
            this.afterCashCapitalInfo = parseFloat(cash).toFixed(2);

            //warning ratio after add values - increase capital
            let afterWarningRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value))-((parseFloat(this.bond)+parseFloat(value))*parseFloat(this.warning_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value)))*100;
            this.warning_line_ratio_increase_info_after = parseFloat(afterWarningRatio).toFixed(2);

            //closing ratio after add values - increase capital
            let afterClosingRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value))-((parseFloat(this.bond)+parseFloat(value))*parseFloat(this.close_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value)))*100;
            this.close_line_ratio_increase_info_after = parseFloat(afterClosingRatio).toFixed(2);

            //warning value after add values - increase capital
            let afterWarningData = (parseFloat(this.warning_ratio) * (parseFloat(this.bond) + parseFloat(value))) + (parseFloat(this.multiple) * parseFloat(value)) + parseFloat(this.number);
            this.warningIncreaseInfoAfter = parseFloat(afterWarningData).toFixed(2);

            //closing value after add values - increase capital
            let afterClosingData = (parseFloat(this.close_ratio) * (parseFloat(this.bond) + parseFloat(value))) + (parseFloat(this.multiple) * parseFloat(value)) + parseFloat(this.number);
            this.closeIncreaseInfoAfter = parseFloat(afterClosingData).toFixed(2);
        }else{
            this.afterCashCapitalInfo = parseFloat(this.cashCapitalInfo).toFixed(2);
            this.balanceAfter = this.balance;
            this.warningIncreaseInfoAfter = this.warningIncreaseInfo;
            this.closeIncreaseInfoAfter = this.closeIncreaseInfo;
            this.warning_line_ratio_increase_info_after = this.warning_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
            this.close_line_ratio_increase_info_after = this.close_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
        }
      },
      addBondMoney: function (value){
        if(value){
            //capital account balance after add values - increase bond
            let after_total = (parseFloat(value) + parseFloat(this.balance));
            this.balanceAfter = parseFloat(after_total).toFixed(2);

            //main after add values - increase bond
            let cash = (parseFloat(this.cashBondInfo) - parseFloat(value));
            this.afterCashBondInfo = parseFloat(cash).toFixed(2);

            //warning ratio after add values - increase bond
            let afterWarningRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.warning_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value)))*100;
            //let afterWarningRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.warning_ratio)))/parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))*100;
            this.warning_line_ratio_increase_bond_info_after = parseFloat(afterWarningRatio).toFixed(2);

            //closing ratio after add values - increase bond
            let afterClosingRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.close_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value)))*100;
            //let afterClosingRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.close_ratio)))/parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))*100;
            this.close_line_ratio_increase_bond_info_after = parseFloat(afterClosingRatio).toFixed(2);
        }else{
            this.afterCashBondInfo = parseFloat(this.cashBondInfo).toFixed(2);
            this.balanceAfter = this.balance;
            this.warning_line_ratio_increase_bond_info_after = this.warning_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');
            this.close_line_ratio_increase_bond_info_after = this.close_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');
        }
      }
  },
    methods: {
      fetch_is_short_trading_enable() {
        let that = this;
        that.$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: 'sysconfig',
            name: 'is_short_trading_enable'
          }
        })
          .then(ret => {
            let resData = ret.data;
            console.log(resData)
            if (resData.code === 1) {
              that.is_short_trading_enable = resData.data;
            }
          });
      },
      getNowData() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "current_operate",
              token: sessionStorage.getItem("token")
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.currentAllList = res.data.data;
              that.currentList = res.data.data;
            } else if (res.data.code == 0) {
              that.$message.error(res.data.msg);
            }
          });
      },

      changeList(type) {
        let that = this;
        let temp = [];
        switch (type) {
          case 'all':
            that.currentList = that.currentAllList;
            break;
          case 'day':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 1) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
          case 'week':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 3) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
          case 'month':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 2) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
          case 'free':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 4||that.currentAllList[i].capital_type === 5||that.currentAllList[i].capital_type === 6) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
        }
      },
      //利润提取 - 显示
      showProfit(cid) {
        let that = this;
        that.cid = cid;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "profit_out",
            token: sessionStorage.getItem("token"),
            cid: cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.extractProfit = res.data.data.profit;
              that.extractMax = res.data.data.max;
              $(".show2Box").fadeIn(50);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      //利润提取 - 隐藏
      hiddenProfit() {
        $(".show2Box").fadeOut(50);
      },
      //利润提取 - 操作
      operationProfit() {
        let that = this;
        if (that.extractMoney == "") {
          that.$message.error("请输入提取金额");
        } else {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "profit_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.extractMoney
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 1000
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
          $(".show2Box").fadeOut(50);
        }
      },
      //追加超盘 - 显示
      showAdd(cid) {
        let that = this;
        that.addMoney = "";
        that.cid = cid;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_capital_info",
            token: sessionStorage.getItem("token"),
            cid: cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.balance = res.data.data.total;
              that.minAdd = res.data.data.min_increase;
              that.warningIncreaseInfo = res.data.data.warning;
              that.closeIncreaseInfo = res.data.data.close;
              that.warning_line_ratio_increase_info = res.data.data.warning_line_ratio;
              that.close_line_ratio_increase_info = res.data.data.close_line_ratio;
              that.multiple = res.data.data.multiple;
              that.number = res.data.data.number;
              that.bond = res.data.data.bond;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.increase_bond_capital = res.data.data.increase_bond;
              that.cashCapitalInfo = res.data.data.cash;

              that.afterCashCapitalInfo = that.cashCapitalInfo;
              that.balanceAfter = that.balance;
              that.warningIncreaseInfoAfter = that.warningIncreaseInfo;
              that.closeIncreaseInfoAfter = that.closeIncreaseInfo;
              that.warning_line_ratio_increase_info_after = that.warning_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_increase_info_after = that.close_line_ratio_increase_info.replace(/[^0-9.-]/g, '');

              $(".show3Box").fadeIn(50);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      //追加超盘 - 隐藏
      hiddenAdd() {
        $(".show3Box").fadeOut(50);
      },
      //追加超盘 - 操作
      operationAdd() {
        let that = this;
        if (that.addMoney == "") {
          that.$message.error("请输入追加金额");
        } else {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_capital_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addMoney
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 1000
                });
                that.getNowData();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
          $(".show3Box").fadeOut(50);
        }
      },
      //追加履约金 - 显示
      showBondAdd(cid) {
        let that = this;
        that.addBondMoney = "";
        that.cid = cid;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_bond_info",
            token: sessionStorage.getItem("token"),
            cid: cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.balance = res.data.data.total;
              that.minBondAdd = res.data.data.min_bond;
              that.warningIncreaseBondInfo = res.data.data.warning;
              that.closeIncreaseBondInfo = res.data.data.close;
              that.warning_line_ratio_increase_bond_info = res.data.data.warning_line_ratio;
              that.close_line_ratio_increase_bond_info = res.data.data.close_line_ratio;
              that.multiple = res.data.data.multiple;
              that.number = res.data.data.number;
              that.bond = res.data.data.bond;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.increase_bond = res.data.data.increase_bond;
              that.cashBondInfo = res.data.data.cash;

              that.afterCashBondInfo = that.cashBondInfo;
              that.balanceAfter = that.balance;
              that.warning_line_ratio_increase_bond_info_after = that.warning_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_increase_bond_info_after = that.close_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');

              $(".show4Box").fadeIn(50);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      //追加履约金 - 隐藏
      hiddenBondAdd() {
        $(".show4Box").fadeOut(50);
      },
      //追加履约金 - 操作
      operationBondAdd() {
        let that = this;
        if (that.addBondMoney == "") {
          that.$message.error("请输入追加金额");
        } else {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_bond_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addBondMoney
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 1000
                });
                that.getNowData();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
          $(".show4Box").fadeOut(50);
        }
      },
      //申请结算 - 显示
      showSettlement(cid) {
        $(".show1Box").fadeIn(50);
        this.cid = cid;
      },
      //申请结算 - 隐藏
      hiddenSettlement() {
        $(".show1Box").fadeOut(50);
      },
      //申请结算 - 操作
      operationSettlement() {
        let that = this;
        $(".show1Box").fadeOut(50);
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "settlement",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose:function () {
                  that.getNowData();
                  that.getHistoryData();
                  document.documentElement.scrollTop = document.body.scrollTop = 0;
                  that.activeName = '2';
                }
              });
              // window.sessionStorage.setItem("accountType", 3);
              // this.$store.state.accountType = 3;
              // that.$router.push({
              //   path: "/myaccount/strategyhistory"
              // });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      getHistoryData() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "history_operate",
              token: sessionStorage.getItem("token")
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.historyList = res.data.data;
            } else if (res.data.code == 0) {
              that.$message.error(res.data.msg);
            }
          });
      },
      //去详情
      goDetails(cid) {
        window.sessionStorage.setItem("cid", cid);
        this.$router.push({
          path: "/myaccount/strategyhistorydetails"
        });
      },
      //去申请配资子账户
      goApply() {
        this.$router.push({
          path: '/operate/operateday'
        })
      },
      //获取对账单
      getCapitalData(cid, information) {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'capital_log',
              'token': window.sessionStorage.getItem('token'),
              'cid': cid
            }
          }).then(res => {
          if (res.data.code == 1) {
            let capitalData = res.data.data;
            switch (information) {
              case 'all':
                that.capitalState = true;
                that.capitalData = capitalData;
                break;
              case 'ensure':
                that.moneyState = true;
                let ensure = [];
                for (let i = 0, len = capitalData.length; i < len; i++) {
                  if (capitalData[i].typeState === 2 || capitalData[i].typeState === 14) {
                    ensure.push(capitalData[i]);
                  }
                }
                that.moneyData = ensure;
                break;
              case 'money':
                that.moneyState = true;
                let money = [];
                for (let i = 0, len = capitalData.length; i < len; i++) {
                  if (capitalData[i].typeState === 1 || capitalData[i].typeState === 2 || capitalData[i].typeState === 13 || capitalData[i].typeState === 14) {
                    money.push(capitalData[i]);
                  }
                }
                that.moneyData = money;
                break;

            }

          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
      },

      //获取持仓
      getHoldData(cid){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'depot_stock',
              'token': window.sessionStorage.getItem('token'),
              'cid': cid
            }
          })  .then(res => {
          if (res.data.code == 1) {
            that.holdState = true;
            var dataArr = res.data.data;
            var shortArr = [];
            if (dataArr.length != 0) {
              $.each(dataArr, function(index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr, dataArr);
              /*clearInterval(window.timer1);
              window.timer1 = setInterval(function() {
                that.getNewPrice(shortArr, dataArr);
              }, 1000);*/
            }else{
              that.holdData = dataArr;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
      },
      //请求当前价 计算 盈亏  盈亏比例
      getNewPrice(shortArr, dataArr) {
        let that = this;
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function() {
            var i, elements;
            for (i = 0; i < shortArr.length; i++) {
              var elements = eval("v_" + shortArr[i]).split("~");
              dataArr[i]["newPrice"] = elements[3]; //当前价
              var newPrice = parseFloat(elements[3]); //当前价
              var number = parseFloat(dataArr[i].number); //持有股数
              var costPrice = parseFloat(dataArr[i].price); //成本价
              var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
              var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
              var market = (newPrice * number).toFixed(2); //当前市值
              priceRatio = priceRatio.toFixed(2);
              dataArr[i]["profitPrice"] = profitPrice;
              dataArr[i]["priceRatio"] = priceRatio;
              dataArr[i]["market"] = market;
            }
            that.holdData = dataArr;
          }
        });
      },

      openDetailed(cid){
        let that = this;
        that.$router.push('/stockmarket/rise');
      }
    }
  };
</script>
<style scoped>
  @import url("./../assets/css/entrust.css");

  .font12 {
    font-size: 10px;
  }

  .show_content_strategynow{
      border: 1px solid #ccc !important; 
      border-radius: 10px ;
      width:550px !important;
      height:210px !important;
      font-size: 15px;
      font-weight: 100;
  }
  .strategynow_matching_amt{
      border: 1px solid #ccc !important; 
      border-radius: 10px ;
      width:550px !important;
      height:50px !important;
      margin-bottom: 15px !important;
      padding:30px !important;
      background-color:white !important;
  }
  .percentageColor{
      color:red;
  }
 /deep/ .el-tabs__item.is-active {
    color: #D02E27 !important;
}
 /deep/ .el-tabs__item:hover {
color: #D02E27 !important;
}
 /deep/ .el-tabs__active-bar{
background-color:#D02E27 !important;
}
/deep/ .button_red_outline{
  border:2px solid #D02E27 !important;
  color:#D02E27 !important;
  border-radius:8px; 
}

/deep/ .entrust_ul_not_active:hover {
  background: #D02E27 !important;
  color: #fff !important;
  border: 1px solid #D02E27;
}

/deep/ .entrust_ul_active{
  border:1px solid #D02E27 !important;
  border-radius: 8px;
}

/deep/ .entrust_ul_active a{
  color:#D02E27 !important;
}

/deep/ .entrust_ul_active:hover{
  background-color:white !important;
}
.entrust_ul > li:nth-child(2) a{
  color: #81718b !important;
}
.entrust_ul > li:nth-child(2) a:hover{
  color: #fff !important;
}
/deep/ .button_red_color,.button_red_color:hover{
    border:#D02E27 !important;
    background-color: #D02E27 !important;
}
/deep/ .show2_content_a {
  width: 500px;
  margin: 0 auto;
  text-align: left;
  font-size: 18px;
}
/deep/ .show3,.show4{
  border-radius:0px !important;
  border:2px solid #ccc !important;
  padding-right:50px;
}

/deep/ .show_foot button {
  position: absolute;
  left: 0;
  right: 0;
  display: inline-block;
  width: 212px;
  margin: 0 auto;
  height: 57px;
  background-color: #566b96;
  padding: 0;
  outline: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
.capital_d1 {
    display: inline-block;
    margin-top: 33px;
    margin-left: 30px;
    color: #3c3a45;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
  }

  .capital_d1 > span {
    display: inline-block;
    color: #3c3a45;
    font-weight: 600;
    margin-left: 36px;
    font-weight: 100;
  }

  .capital_d2 {
    display: inline-block;
    width: 370px;
    color: #656974;
    font-size: 13px;
    line-height: 13px;
    margin: 20px 0 20px 30px;
  }

  .capital_d2 > span {
    display: inline-block;
    margin-left: 30px;
  }
</style>





// WEBPACK FOOTER //
// src/components/strategynow.vue